import { render, staticRenderFns } from "./scriptInput.vue?vue&type=template&id=ddc1f5b0&scoped=true&"
import script from "./scriptInput.vue?vue&type=script&lang=js&"
export * from "./scriptInput.vue?vue&type=script&lang=js&"
import style0 from "./scriptInput.vue?vue&type=style&index=0&id=ddc1f5b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc1f5b0",
  null
  
)

export default component.exports